import React, { useState } from 'react';
import styled from 'styled-components';
import AuthInputComponent from '../../components/AuthInputComponent';
import AuthFooter from '../../components/auth/AuthFooter';
import {
  LoginPageUrl,
  FindIdPageUrl,
  ResultPasswordPageUrl,
} from '../../url/poenUrl';
import { useNavigate } from 'react-router';
import AuthBackgroundLogo from '../../components/auth/AuthBackgroundLogo';
import AuthLogo from '../../components/auth/AuthLogo';
import AuthService from '../../api/service/auth/AuthService';
import LoadingOverlay from '../../components/LoadingOverlay';
import PermissionRedirect from '../../components/PermissionRedirect';

const Container = styled.div`
  padding: 20px;
  font-family: 'Pretendard', sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-color: #fff;
  position: relative;
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 20px;
`;

const FindIdForm = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
`;

const Button = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 10px;
  border: none;
  font-size: 16px;
  color: white;
  cursor: pointer;

  background-color: ${({ theme }) => theme.colors.mainColor};

  &:hover {
    background-color: ${({ theme }) => theme.colors.hoverColor};
  }
`;

const FindPasswordPage = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [identifier, setIdentifier] = useState('');
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false); // 로딩 상태 추가

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (!name || !identifier || !email) {
      alert('모든 필드를 입력해 주세요.');
      return;
    }

    setIsLoading(true); // 로딩 시작
    try {
      const response = await AuthService.passwordFind({
        name,
        identifier,
        email,
      });
      console.log('비밀번호 찾기 성공:', response);
      navigate(ResultPasswordPageUrl); // 결과 페이지로 이동
    } catch (err) {
      console.error('비밀번호 찾기 실패:', err);
      alert(err);
    } finally {
      setIsLoading(false); // 로딩 종료
    }
  };

  return (
    <Container>
      <PermissionRedirect />
      {isLoading && <LoadingOverlay />} {/* 로딩 중일 때 오버레이 표시 */}
      <AuthLogo />
      <Title>비밀번호 찾기</Title>
      <FindIdForm>
        <Form onSubmit={handleSubmit}>
          <AuthInputComponent
            type="text"
            placeholder="이름을 입력해 주세요"
            value={name}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setName(e.target.value)
            }
          />
          <AuthInputComponent
            type="text"
            placeholder="아이디를 입력해 주세요"
            value={identifier}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setIdentifier(e.target.value)
            }
          />
          <AuthInputComponent
            type="email"
            placeholder="이메일주소를 입력해 주세요"
            value={email}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setEmail(e.target.value)
            }
          />
          <Button type="submit">확인</Button>
        </Form>
        <AuthFooter
          firstUrl={LoginPageUrl}
          secondUrl={FindIdPageUrl}
          findIdText="로그인"
          findPasswordText="아이디 찾기"
        />
      </FindIdForm>
      <AuthBackgroundLogo />
    </Container>
  );
};

export default FindPasswordPage;
